import { get } from "lodash";
import React, { useState } from "react";
import useStyles from "./styles";
import { Box, Typography } from "@material-ui/core";
import ObjectiveWidgetsListBody from "Components/modal/ObjectiveWidgetsList/ObjectiveWidgetsListBody";
import TargetTitleTag from "Components/TargetTitleTag";
import { useWatch } from "react-hook-form";
import Scrollbars from "react-custom-scrollbars";

const CarouselContent = (props) => {
  // const methods = useFormContext();
  const classes = useStyles();
  const { objectiveList } = useWatch();
  const [currentIndex] = useState(0);

  return (
    <Box className={classes.root}>
      <TargetTitleTag
        targetData={props.selectedObjective}
        routeState={{ currentTab: "objective" }}
      />
      <Box height="255px" p={0.5} mt={1}>
        <Box
          px={2}
          display="flex"
          alignItems="center"
          className={classes.tableHeader}
        >
          <Typography variant="body2" className={classes.colTitle}>
            Objectives ({props?.objectives?.length})
          </Typography>
          <Typography variant="body2" className={classes.colComment}>
            Comments
          </Typography>
          <Typography variant="body2" className={classes.colStatus}>
            Status
          </Typography>
        </Box>
        <Box height="210px" className={classes.listWrapper}>
          <Scrollbars>
            <Box p={1.5}>
              <ObjectiveWidgetsListBody
                {...props}
                targetId={get(props, "selectedObjective.id", "")}
              />
            </Box>
          </Scrollbars>
        </Box>
      </Box>
    </Box>
  );
};

export default CarouselContent;
